// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__b8uIP","row":"default_row__PS2Wq","link":"default_link__gLg+y"};